import React from 'react'

const Footer = () => {
    return (
        <>
            <hr />
            <div className='conatiner-fluid' style={{ backgroundColor: '#d2d1d1', padding: '1rem', marginBottom: '1px' }}>
                <div className='row' >
                    <p>

                    </p>
                    <marquee width="100%" behavior="alternate" scrollamount='15' scrdirection="right" height="auto" style={{ color: 'red', marginTop: '1rem' }}>
                        Harikeshmaurya9984@gmail.com
                    </marquee>
                    <p style={{ textAlign: 'center' }}>
                        ❤️2023❤️  created by harkesh maurya ❤️2023❤️
                    </p>



                </div>
            </div>
        </>
    )
}

export default Footer;